export class SendEmailError extends Error {
    public message: string

    constructor(message: string) {
        super()
        this.message = message
    }
}

export const ERROR = {
    POST_SEND_EMAIL_FAIL: "POST to send-email fail"
}
